module.exports = __webpack_public_path__ + "img/stairwell-medium.23155a73.png";